import { render, staticRenderFns } from "./ImageModal.vue?vue&type=template&id=df1571f8&scoped=true&"
import script from "./image-modal.ts?vue&type=script&lang=ts&"
export * from "./image-modal.ts?vue&type=script&lang=ts&"
import style0 from "./ImageModal.vue?vue&type=style&index=0&id=df1571f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1571f8",
  null
  
)

export default component.exports